import {checkValid} from "@/components/globalModels/functions/ModelsValidate";

export function StockNotify() {

  this.checkValid = checkValid

  this.data = {
    notify: false,

    minNumber: '',

    emails: [new StockNotifyEmails()],
  }

  this.validation = {
    minNumber: false,
  }

  this.validationTranslate = {
    minNumber: '',
  }

  this.validationTxt = {
    minNumber: false,
  }

  /**
   * Getters
   */
  
  this.getProductsForCellArray = () => {
    return this.data.productsForCellArray
  }


  /**
   * Setters
   */
 
  this.setProductsForCellArray = (val) => {
    this.data.productsForCellArray = val
  }
  
}


/**
 * Global Setters
 */

StockNotify.prototype.setItem = function (item) {
  this.data.notify = item.notify
  this.data.minNumber = item.stock_count
  item.emails.forEach(email => {
    this.addEmail(email)
  })

}


/**
 * Functions
 */

StockNotify.prototype.addEmail = function (email) {
  if(email) {
    if(this.data.emails[this.data.emails.length - 1].data.email.length !== 0) {
      this.data.emails.push(new StockNotifyEmails())
    }

    this.data.emails[this.data.emails.length - 1].data.email = email
    return
  }

  this.data.emails.push(new StockNotifyEmails())
}

StockNotify.prototype.deleteEmail = function (index) {
  this.data.emails.splice(index, 1)
}


/**
 * Validations
 */

StockNotify.prototype.validateItem = function () {

  let validationItems = {
    minNumber: this.data.minNumber,
  }

  let validationOptions = {
    minNumber: {type: ['numeric', 'empty']},
  }

  let valid = true

  this.data.emails.forEach(item => {
    if(!item.validateItem()) {
      valid = false
    }
  })

  return (this.checkValid(validationItems, validationOptions)) && valid
}

/**
 * Prepare Data
 */

StockNotify.prototype.prepareSave = function () {

  return {
    "notify": this.data.notify,
    "stock_count": this.data.minNumber,
    "emails": this.data.emails.map(item => item.data.email)
  }

}

function StockNotifyEmails() {
  this.checkValid = checkValid

  this.data = {
    email: '',
  }

  this.validation = {
    email: false,
  }

  this.validationTranslate = {
    email: '',
  }

  this.validationTxt = {
    email: false,
  }

  this.setItem = (item) => {
    this.data.email = item
  }

  this.validateItem = () => {
    let validationItems = {
      email: this.data.email,
    }

    let validationOptions = {
      email: {type: ['email', 'empty']},
    }

    return (this.checkValid(validationItems, validationOptions))
  }


}
